import { useTheme } from '@mui/material';

export const RealWorldEvidenceIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke, tertiary: tertiaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={41} height={40} fill="none">
            <rect
                width={31}
                height={32}
                x={10}
                y={6}
                fill={primaryBackground}
                opacity={0.5}
                rx={2}
            />
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M4.5 3.5V34H37"
            />
            <path
                stroke={primaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="m8.5 27 4-4 2.5 2.5 5.5-5.5"
            />
            <circle
                cx={26.909}
                cy={13.159}
                r={5.75}
                stroke={tertiaryStroke}
                strokeWidth={1.5}
                transform="rotate(-45 26.909 13.159)"
            />
            <path
                stroke={tertiaryStroke}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="m31.152 17.402 3.535 3.535M28.677 11.391l-3.536 3.536"
            />
        </svg>
    );
};
